/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/scan */
import{operate as n}from"rxjs/dist/esm/internal/util/lift";import{scanInternals as e}from"rxjs/dist/esm/internal/operators/scanInternals";function m(r,t){return n(e(r,t,arguments.length>=2,!0))}export{m as scan};
//# sourceMappingURL=scan.mjs.map